<template>
  <div class="right-details-box">
    <div class="details-box">
      <div class="details-title Overview"><img src="../assets/Overview.png" alt="概览"></div>
      <div class="details-centent">
        <dl>
          <dt>标题：</dt>
          <dd>{{ webinarInfo.title }}</dd>
        </dl>
        <dl>
          <dt>日期：</dt>
          <dd>{{ webinarInfo.timeToShow }}</dd>
        </dl>
      </div>
      <div class="details-count-down">
        <span class="timespan" @click="linkToWebinar">查看详情</span>
      </div>
    </div>
    <div class="details-box introduction-box">
      <div class="details-title"><img src="../assets/MeetingDetails.png" alt="会议详情"></div>
      <div class="details-img" v-if="webinarInfo.detailImg" @click="linkToWebinar"><img :src="webinarInfo.detailImg" alt=""></div>
      <div class="details-introduction" v-html="webinarInfo.intro"></div>
    </div>
    <div class="details-box toast-box">
      <div class="details-title">
        <img src="../assets/Speakers.png" alt="演讲嘉宾">
      </div>
      <div class="toast-list">
        <div class="toast-dl" v-for="guest in webinarInfo.speakerList" @click="showDetails(guest)">
          <div class="toast-img">
            <img :src="'http://s2-content.smarket.net.cn/index.php?mappingId='+guest.imageMapId" width="100%" alt="">
          </div>
          <div class="toast-text">
            <span v-html="guest.name"></span>
            <p v-html="guest.enterprise"></p>
          </div>
        </div>
      </div>
      <guest-details :_is-show="isShowGuestDetails" :_is-wap="isWap" :details="guest" @hideDetails="hideDetails"/>
    </div>
    <partial-loading :_is-show="isShowLoading"/>
  </div>
</template>

<script>
import bus from "../utils/eventBus";
import { mapState } from "vuex";
import moment from "moment";
import "moment/locale/zh-cn";
import PartialLoading from "./PartialLoading";
import GuestDetails from "./GuestDetails";

export default {
  name: "WebinarDetails",
  props: ["itemInfo"],
  components: {
    PartialLoading,
    GuestDetails
  },
  data: function() {
    return {
      webinarInfo: {},
      customFormId: "",
      isShowLoading: false,
      isShowGuestDetails: false,
      guest: {}
    };
  },
  computed: {
    ...mapState({
      instanceId: function(state) {
        return this.itemInfos.instanceId
          ? this.itemInfos.instanceId
          : state.instanceId;
      },
      loginStatus: "loginStatus"
    }),
    itemInfos() {
      return this.itemInfo || {};
    },
    isWap() {
      return $(document).width() <= 750;
    }
  },
  watch: {
    instanceId: function() {
      this.loadDetails(this.instanceId);
    }
  },
  created: function() {
    if (this.instanceId !== 0) {
      this.loadDetails(this.instanceId);
    }
  },
  methods: {
    loadDetails: function(instanceId) {
      this.isShowLoading = true;
      $.ajax({
        url: window.config.api.gateway.general + "/webinar/open/getWebinarInfo",
        type: "post",
        dataType: "json",
        data: {
          tenantId: smarket.Config("tenantId"),
          instanceId: instanceId,
          includeCustomField: 1
        }
      }).then(data => {
        this.customFormId = data.body.content.customFormId;
        let meetingInfo = data.body.content.eventInfo;
        meetingInfo.isForeshow = meetingInfo.Demand ? 2 : 1;
        if (meetingInfo.isForeshow === 2) {
          meetingInfo.demandInstanceId = meetingInfo.Demand.enterShortUrl.replace(
            /[^0-9]/gi,
            ""
          );
        }
        meetingInfo.timeToShow =
          moment(meetingInfo.startTime * 1000).format(
            "YYYY年MM月DD日，dddd，HH:mm-"
          ) + moment(meetingInfo.endTime * 1000).format("HH:mm");
        if(meetingInfo.customFieldItems && meetingInfo.customFieldItems.length){
          meetingInfo.customFieldItems.forEach(item => {
            if (item.fieldName === "detailImg") {
              meetingInfo.detailImg = item.value;
            }
          });
        }
        this.webinarInfo = meetingInfo;
        this.isShowLoading = false;
      });
    },
    linkToWebinar: function() {
      if (this.loginStatus === 0) {
        bus.$emit("showToast", "想要观看课程，请先“注册”或“登录”");
      } else {
        if (!this.isWap) {
          window.open(
            this.webinarInfo.isForeshow === 2
              ? "https://kee.smarket.net.cn/2019/template/template/demand/release/Demand/PC/Default/html/onDemandInfo.html?instanceId=" +
                this.webinarInfo.demandInstanceId +
                "&webinarId=" +
                this.webinarInfo.parentId
              : "https://kee.smarket.net.cn/2019/template/template/newTemplate/release/Webinar/PC/Common/html/meetingInfo.html?instanceId=" +
                this.instanceId +
                "&webinarId=" +
                this.webinarInfo.webinarId
          );
        } else {
          window.location.href =
            this.webinarInfo.isForeshow === 2
              ? "https://kee.smarket.net.cn/2019/template/template/demand/release/Demand/WAP/Default/html/onDemandInfo.html?instanceId=" +
                this.webinarInfo.demandInstanceId +
                "&webinarId=" +
                this.webinarInfo.parentId
              : "https://kee.smarket.net.cn/2019/template/template/newTemplate/release/Webinar/WAP/Common/html/meetingInfo.html?instanceId=" +
                this.instanceId +
                "&webinarId=" +
                this.webinarInfo.webinarId;
        }
      }
    },
    showDetails: function(guest) {
      this.guest = guest;
      this.isShowGuestDetails = true;
    },
    hideDetails: function() {
      this.isShowGuestDetails = false;
    }
  }
};
</script>

<style scoped lang="scss">
.right-details-box {
  padding: 28px 32px;
  margin-top: 6px;
  background: #f7f7f7;
  position: relative;
}

.details-img {
  margin-top: 10px;
}

.details-img img {
  width: 100%;
}

.details-title {
  width: 100px;
  overflow: hidden;
  padding: 2px 0;

  &.Overview {
    width: 60px;
  }

  img {
    height: 19px;
    display: block;
  }
}

.details-centent {
  padding: 0 5px;
}

.details-centent dl {
  width: 100%;
  overflow: hidden;
  margin: 17px 0 0;
  display: flex;
}

.details-centent dl dt {
  flex: none;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  color: #524f56;
  font-size: 15px;
  font-weight: bold;
}

.details-centent dl dd {
  line-height: 24px;
  color: #524f56;
  font-size: 15px;
  margin: 0;
}

.details-count-down {
  text-align: center;
  overflow: hidden;
  margin: 20px auto 0;
}

.details-count-down .timespan {
  background: #e90029;
  font-size: 15px;
  color: #f7f7f7;
  padding: 12px 50px;
  margin: 0;
  display: inline-block;
  border-radius: 2px;
  cursor: pointer;
}

.details-count-down span i {
  margin-left: 12px;
  font-style: normal;
}

.introduction-box {
  margin-top: 25px;
}

.details-introduction {
  padding: 5px;
  margin-top: 13px;
  background: url("../assets/icon-right-syh.png") left top no-repeat;
  text-indent: 25px;
  line-height: 24px;
  font-size: 15px;
  color: #524f56;
  text-align: justify;
  width: 100%;
  overflow: hidden;
}

.details-ktsImg {
  img {
    width: 100%;
  }
}

.toast-box {
  margin-top: 35px;
  position: relative;
}

.toast-list {
  /*padding-bottom: 30px;*/
  position: relative;
}

.toast-dl {
  width: 100%;
  overflow: hidden;
  margin: 17px 0 0;
  display: flex;
  align-items: center;
}

.toast-img {
  flex: 0 0 97px;
  padding: 5px 5px 0 0;
  background: url("../assets/icon-img-bj.png") right top no-repeat;
}

.toast-img img {
  display: block;
  border-radius: 50%;
  float: left;
  width: 92px;
  height: 92px;
  background: #ffffff;
}

.toast-text {
  flex: auto;
  margin-left: 23px;
}

.toast-text span {
  width: 100%;
  float: left;
  line-height: 24px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  /* margin-top: 20px;*/
  font-size: 18px;
  color: #524f45;
}

.toast-text p {
  width: 100%;
  margin: 10px 0 0;
  float: left;
  line-height: 24px;
  color: #524f56;
  font-size: 15px;
  text-align: left;
}

/* web */
@media screen and (max-width: 750px) {
  .right-details-box {
    padding: pxToRem(30) pxToRem(26);
    margin: pxToRem(0) pxToRem(28);
  }
  .details-title {
    width: 100%;
    overflow: hidden;
    padding: pxToRem(4) 0;

    &.Overview {
      width: 100%;
    }

    img {
      height: pxToRem(28);
      display: block;
    }
  }
  .details-img {
    margin-top: pxToRem(10);
  }
  .details-img img {
    width: 100%;
  }
  .details-centent {
    padding: 0 pxToRem(8);
  }
  .details-centent dl {
    margin: pxToRem(27) 0 0;
  }
  .details-centent dl dt {
    font-size: pxToRem(24);
    line-height: pxToRem(37);
  }
  .details-centent dl dd {
    font-size: pxToRem(24);
    line-height: pxToRem(37);
  }
  .details-count-down {
    margin: pxToRem(30) auto 0;
  }
  .details-count-down .timespan {
    padding: pxToRem(20) pxToRem(80) !important;
    font-size: pxToRem(26) !important;
  }
  .details-introduction {
    background: url("../assets/web-icon-right-syh.png") left top no-repeat;
    background-size: pxToRem(44) pxToRem(38);
    text-indent: pxToRem(58);
    font-size: pxToRem(24);
    line-height: pxToRem(35);
    padding: pxToRem(5) pxToRem(24) pxToRem(18);
    margin-top: pxToRem(20);
  }
  .introduction-box {
    margin-top: pxToRem(45);
  }
  .toast-box {
    margin-top: pxToRem(45);
  }
  .toast-dl {
    margin-top: pxToRem(22);
  }
  .toast-img {
    flex: 0 0 pxToRem(150);
    background: url("../assets/web-icon-img-bj.png") right top no-repeat;
    height: pxToRem(142);
    padding: pxToRem(7) pxToRem(9);
    background-size: pxToRem(135) pxToRem(135);
  }
  .toast-img img {
    width: pxToRem(135);
    height: pxToRem(135);
  }
  .toast-text {
    margin-left: pxToRem(35);
  }
  .toast-text span {
    margin-top: pxToRem(30);
    font-size: pxToRem(26);
    line-height: pxToRem(35);
  }
  .toast-text p {
    margin-top: pxToRem(15);
    font-size: pxToRem(22);
    line-height: pxToRem(35);
  }
  .toast-list {
    padding-bottom: pxToRem(48);
    border: none;
    position: relative;
  }
}
</style>

<style lang="scss">
::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.details-introduction {
  img {
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 100%;
    -webkit-transform: scale(1) rotate(0) translate3d(0, 0, 0);
    transform: scale(1) rotate(0) translate3d(0, 0, 0);
  }

  p:last-child {
    display: inline;
  }

  p {
    margin: 0 0 10px 0;
  }
}
</style>
